export const SvgFullscreen = '%3Csvg%20xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg"%20viewBox%3D"0%200%2030%2030"%3E%3Cpath%20d%3D"M0%2019.78V30h10.23v-2.42H2.66v-7.8Zm27.34%200v7.8h-7.58V30H30V19.78ZM0%200v10.23h2.66V2.38h7.57V0Zm19.76%200v2.38h7.57v7.85H30V0Z"%2F%3E%3C%2Fsvg%3E';
export default SvgFullscreen;
